module.exports = __webpack_public_path__ + "static/media/Silestone-Flash-Promo-Flyer-Canada.f5b37666.pdf";